<template>
    <main class="app">
        <div class="main-header">
            <h1>Auditoría de usuarios</h1>
            <button
                v-if="logs && !emptyLogsQuery"
                class="btn btn--with-icon export-xls"
                :class="{'btn--loading': loadingButton}"
                @click="exportCsv"
            >
                <img
                    alt="Atributo negociable"
                    src="@/assets/images/excel.svg"
                />
                Exportar CSV
            </button>
        </div>

        <div class="row row-sm-column audit-logs">
            <div class="col-9 col-sm-12 order-sm-last">
                <div v-if="!logs && !isLoading" class="alert info vertical-align">
                    <vs-icon icon="error"></vs-icon>
                    Debe completar todos los filtros para poder obtener
                    resultados.
                </div>
                <br>
                <div v-if="!logs && !isLoading" class="alert info vertical-align">
                    <vs-icon icon="error"></vs-icon>
                    Para activar o desactivar el registro de logs puede hacerlo desde Configuraciones > General > Logs.
                </div>


                <div
                    v-else-if="emptyLogsQuery && !isLoading"
                    class="alert info"
                >
                    <vs-icon icon="error"></vs-icon>
                    Sin resultados para mostrar.
                </div>

                <audit-logs-list
                    v-else
                    v-show="!isLoading"
                    ref="logsList"
                    :groupByGuid="showByGuid"
                    :logs="showByGuid ? logsByGuid : logs"
                    :paginationTotalPages="paginationTotalPages"
                    @filter="getLogs"
                />
            </div>

            <div class="col-3 col-sm-12 order-sm-first filters">
                <audit-logs-filters
                    ref="logsFilters"
                    @filter="getLogsAndResetListIndex"
                />
            </div>
        </div>
    </main>
</template>

<script>
import AuditLogsList from "@/components/admin/AuditLogsList.vue";
import AuditLogsFilters from "@/components/admin/AuditLogsFilters.vue";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";
import { mapState } from "vuex";

const listLogs = gql`
    query listLogs(
        $currentUserToken: String!
        $filters: LogsFilterInput
        $perPage: Int
        $page: Int
    ) {
        listLogs(
            currentUserToken: $currentUserToken
            filters: $filters
            perPage: $perPage
            page: $page
        ) {
            totalPages
            groupedLogs {
                refererGuid
                logs {
                    createdAt
                    action
                    body
                    id
                    ip
                    referer
                    refererGuid
                    userAgent
                    user {
                        email
                        id
                        cuil
                        firstname
                        lastname
                        organization {
                            businessName
                        }
                    }
                }
            }
        }
    }
`;

export default {
    name: "audit-logs-view",
    components: {
        AuditLogsList,
        AuditLogsFilters,
    },
    computed: {
        ...mapState({
            currentUser: (state) => state.User.currentUser,
        }),
    },
    data() {
        return {
            paginationTotalPages: 1,
            logs: "",
            logsByGuid: [],
            isLoading: false,
            emptyLogsQuery: false,
            showByGuid: true,
            itemsPerPage: 21,
            loadingButton: false
        };
    },
    methods: {
        getLogsAndResetListIndex() {
            this.$refs.logsList ? this.$refs.logsList.resetIndex() : null;
            this.getLogs();
        },
        getLogs() {
            this.$vs.loading();
            this.isLoading = true;
            let tempFilter = this.$refs.logsFilters.filters;

            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(listLogs),
                        variables: {
                            currentUserToken: localStorage.getItem(
                                "USER_TOKEN"
                            ),
                            filters: tempFilter,
                            perPage: this.itemsPerPage,
                            page: this.$refs.logsList
                                ? this.$refs.logsList.pagination
                                : 1,
                        },
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        this.logs = [];
                        this.paginationTotalPages =
                            res.data.data.listLogs.totalPages;

                        let groupedLogs = {};
                        res.data.data.listLogs.groupedLogs.map(
                            (e) => (groupedLogs[e.refererGuid] = e.logs)
                        );

                        this.logsByGuid = groupedLogs;
                        this.emptyLogsQuery = false;
                        this.isLoading = false;
                        this.$vs.loading.close()
                    }
                });
        },
        exportCsv() {
            this.loadingButton = true;
            let logsGuidList = Object.keys(this.logsByGuid);
            axios
                .post(`${process.env.VUE_APP_RAILS_PATH}/csvs/logs.csv`, {
                    currentUserToken: localStorage.getItem("USER_TOKEN"),
                    filters: this.$refs.logsFilters.filters,
                    logsGuidList: logsGuidList
                })
                .then((response) => {
                    let date = Date.parse(this.currentUser.currentTime);
                    date = new Date(date)
                        .toLocaleString()
                        .replace(/[^\d]/g, "-");
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `logs-${date}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    this.loadingButton = false;
                });
        },
    }        
};
</script>
<style scoped>
.alert {
    margin: 0px;
}
.vertical-align {
    margin-top: 0px !important;
}
</style>
